import loadAsync from "routing/loadAsync";
const AsyncBasicQueryInput = loadAsync(() => import("./BasicQueryInput"));
export default AsyncBasicQueryInput;
